<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Mining Output"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Participate in ranked matches to earn $FIRE and bounty cases based on character attributes, consuming the
        squad's
        stamina. All mining activities, earnings, and consumption details are recorded.
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>